export const GET_ADMIN_STATIC_DATA = "GET_ADMIN_STATIC_DATA";
export const SET_ADMIN_STATIC_DATA = "SET_ADMIN_STATIC_DATA";
